import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import { ActivityStatusOptions } from '@user/features/Activity/constants'

export function StatusField() {
  return (
    <Field
      component={MuiTextFieldFormik}
      fullWidth
      label="Status"
      margin="normal"
      name="status"
      select
      size="small"
      data-test-id={`activity-form-status-field`}
      inputProps={{ 'data-test-id': 'activity-form-status-field-input' }}
    >
      {ActivityStatusOptions.map((option) => (
        <MenuItem value={option.value as string} key={option.value as string}>
          {option.label}
        </MenuItem>
      ))}
    </Field>
  )
}
